module.exports = __webpack_public_path__ + "img/Lobby_Banner1.7d092bdf.jpg";